import React from 'react';
import { PageSpinner } from '@/components/Spinner/PageSpinner';
import { useGalleryImage } from '@/hooks/useGalleryImage';
import type { GalleryImageItem } from '@/types/gallery';

interface Props {
  image: GalleryImageItem;
}

export const GalleryLightboxSlide: React.FC<Props> = ({ image }) => {
  const url = useGalleryImage(image.id, null);

  return (
    <div className="flex h-full w-full shrink-0 items-center justify-center">
      {url ? (
        <img
          src={url}
          alt={image.fileName}
          draggable={false}
          className="size-full object-contain select-none"
        />
      ) : (
        <PageSpinner />
      )}
    </div>
  );
};
